import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const checkTokenExpiry = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      setLoading(false);
      navigate("/login");
      return;
    }

    try {
      const payload = JSON.parse(atob(accessToken.split(".")[1]));
      const expiry = payload.exp * 1000;
      const now = Date.now();

      if (now > expiry) {
        localStorage.removeItem("accessToken");
        Swal.fire({
          icon: "warning",
          title: "Session Expired",
          text: "Silakan login kembali.",
          confirmButtonText: "OK",
        }).then(() => navigate("/login"));
      } else {
        setLoading(false);
      }
    } catch {
      localStorage.removeItem("accessToken");
      navigate("/login");
    }
  };

  useEffect(() => {
    checkTokenExpiry();
    // Re-check every 30 seconds (no need for 1s polling)
    const id = setInterval(checkTokenExpiry, 30_000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="flex flex-col items-center gap-3">
          <div className="w-10 h-10 border-4 border-brand-200 border-t-brand-600 rounded-full animate-spin" />
          <p className="text-slate-500 text-sm font-overpass">Memverifikasi sesi...</p>
        </div>
      </div>
    );
  }

  return localStorage.getItem("accessToken") ? children : null;
};

export default ProtectedRoute;
